import { $axios, withAuth } from '@/shared/api';

export const getUserProfile = () => {
  return $axios.get('auth/profile', withAuth());
};

export const removeUser = () => {
  return $axios.delete('client/users/profile', withAuth());
};

export const updateUserProfile = ({ user }) => {
  return $axios.patch('client/users/profile', user, withAuth());
};

export const changePassword = (data) => {
  return $axios.post('auth/changePassword', data, withAuth());
};
